<div>
    <ui-page-title [inModal]="true" [pageCode]="pageCode" [showModalHeader]="true"
                   [title]="'' | translate"></ui-page-title>

    <div class="grid pb-5 pt-1">
        <div class="col-12">
            <div class="search-container">
                <p-accordion>
                    <p-accordionTab [header]="'searchCriteria' | translate" [selected]="true">
                        <organization-selection-search-form (onSearchEvent)="onSearch()" [form]="form"
                                                            [pageCode]="pageCode" [isClear]="isClear"
                                                            [showStaffFullnessStatus]="showStaffFullnessStatus"
                                                            (onBack)="isClear = false"></organization-selection-search-form>
                        <ui-advance-search-footer-buttons (onClear)="onClear()" (onSearch)="onSearch()"
                                                          [idPrefix]="pageCode"></ui-advance-search-footer-buttons>
                    </p-accordionTab>
                </p-accordion>
            </div>
        </div>

        <div class="col-12">
            <p-table
                #table
                styleClass="p-datatable-striped"
                [id]="pageCode + '_list'"
                [value]="list"
                [lazy]="true"
                (onLazyLoad)="lazyLoadData($event)"
                [paginator]="true"
                [rows]="10"
                [rowsPerPageOptions]="[10, 20, 50]"
                [totalRecords]="totalElements"
                [loading]="loading"
                [selectionMode]="selectionMode"
                [(selection)]="selectedModel"
                dataKey="{{dataKey}}"
                [resetPageOnSort]="false"
                [resizableColumns]="true"
                [scrollable]="true"
                scrollHeight="450px"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th pFrozenColumn *ngIf="selectionMode && selectionMode != 'single'" style="width: 45px">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th pResizableColumn pSortableColumn="objectNumber" style="width: 10rem">
                            {{ 'hrPerOrganizationGeneralInfo.objectNumber' | translate }}
                            <p-sortIcon field="objectNumber"></p-sortIcon>
                        </th>
                        <th pResizableColumn pSortableColumn="perObjectDefinitionUnitCode" style="width: 6rem">
                            {{ 'hrPerOrganizationGeneralInfo.perObjectDefinitionUnitCode' | translate }}
                            <p-sortIcon field="perObjectDefinitionUnitCode"></p-sortIcon>
                        </th>
                        <th pResizableColumn pSortableColumn="perObjectDefinitionText" style="width: 10rem">
                            {{ 'hrPerOrganizationGeneralInfo.perObjectDefinitionId' | translate }}
                            <p-sortIcon field="perObjectDefinitionId"></p-sortIcon>
                        </th>
                        <th pResizableColumn pSortableColumn="companyName" style="width: 8rem">
                            {{ 'hrPerOrganizationGeneralInfo.accCompanyUuid' | translate }}
                            <p-sortIcon field="companyName"></p-sortIcon>
                        </th>
                        <th pResizableColumn pSortableColumn="perObjectDefinitionPText" style="width: 8rem">
                            {{ 'hrPerOrganizationGeneralInfo.perObjectDefinitionPId' | translate }}
                            <p-sortIcon field="perObjectDefinitionPId"></p-sortIcon>
                        </th>

                        <th pResizableColumn pSortableColumn="status" style="width: 8rem">
                            {{ 'hrPerOrganizationGeneralInfo.status' | translate }}
                            <p-sortIcon field="status"></p-sortIcon>
                        </th>

                        <th pResizableColumn pSortableColumn="managerPerPeopleId" style="width: 8rem">
                            {{ 'hrPerOrganizationGeneralInfo.managerPerPeopleId' | translate }}
                            <p-sortIcon field="managerPerPeopleId"></p-sortIcon>
                        </th>
                        <th pResizableColumn pSortableColumn="provinceText" style="width: 3rem">
                            {{ 'hrPerOrganizationGeneralInfo.provinceText' | translate }}
                            <p-sortIcon field="provinceText"></p-sortIcon>
                        </th>
                        <th pResizableColumn pSortableColumn="subProvinceText" style="width: 3rem">
                            {{ 'hrPerOrganizationGeneralInfo.subProvinceText' | translate }}
                            <p-sortIcon field="subProvinceText"></p-sortIcon>
                        </th>
                        <!--                        <th pResizableColumn style="width: 10rem">-->
                        <!--                            {{ 'hrPerOrganizationGeneralInfo.employeeCount' | translate }}-->
                        <!--                        </th>-->
                        <!--                        <th>-->
                        <!--                            {{ 'hrPerOrganizationGeneralInfo.employeeTotalCount' | translate }}-->
                        <!--                        </th>-->
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-generalInfo>
                    <tr [pSelectableRow]="generalInfo">
                        <td pFrozenColumn *ngIf="selectionMode && selectionMode != 'single'" style="width: 45px">
                            <p-tableCheckbox [value]="generalInfo" [pSelectableRow]="generalInfo"></p-tableCheckbox>
                        </td>
                        <td>{{ generalInfo.objectNumber }}</td>
                        <td>{{ generalInfo.perObjectDefinitionUnitCode }}</td>
                        <td>{{ generalInfo.perObjectDefinitionText }}</td>
                        <td>{{ generalInfo.companyName }}</td>
                        <td>{{ generalInfo.perObjectDefinitionPText }}</td>
                        <td>{{ generalInfo.status }}</td>
                        <td>{{ generalInfo?.name }} {{ generalInfo?.surname }}</td>
                        <td>{{ generalInfo?.provinceText }}</td>
                        <td>{{ generalInfo?.subProvinceText }}</td>
                        <!--                        <td>{{ generalInfo.employeeCount }}</td>-->
                        <!--                        <td>{{ generalInfo.employeeTotalCount }}</td>-->
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="11">{{ 'noRecordsFound' | translate }}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <ui-sticky-buttonbar>
        <div class="mr-2">
            <button [id]="pageCode + '_cancel'" (click)="onCancel()" [label]="'button.cancel' | translate"
                    class="p-button-text" pButton></button>
        </div>
        <div>
            <button [id]="pageCode + '_select'" (click)="onRowSelectClickEvent()" [label]="'addSelected' | translate"
                    pButton></button>
        </div>
    </ui-sticky-buttonbar>
</div>
